import { render, staticRenderFns } from "./HrZoneChart.vue?vue&type=template&id=c60c96c6"
import script from "./HrZoneChart.vue?vue&type=script&lang=js"
export * from "./HrZoneChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports